import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ForecastBudgetBulkUpdateProgress } from './forecasting.budgeting.model';

@Component({
    selector: 'forecasting-budgeting-bulk-updating',
    templateUrl: 'forecasting.budgeting.bulk.updating.component.html',
    standalone: false,
})

export class ForecastingBudgetingBulkUpdatingComponent implements OnInit {
    @Input() bulkUpdateProgress: ForecastBudgetBulkUpdateProgress
    @Input() getCurrentBulkUpdateSelection: () => Core.ForecastGridEntry | null
    @Input() bulkUpdateEntityType: string;

    @Input() bulkUpdateCanceled: boolean;
    @Output() bulkUpdateCanceledChange = new EventEmitter<boolean>();

    @Input() bulkUpdateInProgress: boolean;
    @Output() bulkUpdateInProgressChange = new EventEmitter<boolean>();

    @Output() refresh = new EventEmitter<void>();

    constructor() { }

    
    ngOnInit() { }

    get isBulkUpdateDone(): boolean {
        return this.bulkUpdateProgress.currentIndex >= this.bulkUpdateProgress.selections.length;
    }

    getCurrentBulkUpdateIdentity(): string {
        let identity: string = '';

        const cur = this.getCurrentBulkUpdateSelection();
        if (cur) {
            identity = `[${this.bulkUpdateProgress.currentIndex + 1} of ${this.bulkUpdateProgress.selections.length}]   Site:  ${cur.siteName}`;
            if (cur.entityTypeId === Core.EntityTypes.Parcel) {
                identity += `   Parcel:  ${cur.parcelAcctNum}`;
            }
        }
        return identity;
    }

    cancelBulkUpdate() {
        // Switch page to Bulk Updte Canceled display
        this.bulkUpdateCanceled = true;
        this.bulkUpdateCanceledChange.emit(this.bulkUpdateCanceled);
    }

    endBulkUpdate() {
        // Switch page back to normal display
        this.bulkUpdateCanceled = false;
        this.bulkUpdateCanceledChange.emit(this.bulkUpdateCanceled);
        this.bulkUpdateInProgress = false;
        this.bulkUpdateInProgressChange.emit(this.bulkUpdateInProgress);
        this.bulkUpdateProgress.reset();

        // Refresh grid with applied updates.
        this.refresh.emit();
    }
}